import React from 'react';
import { AppModal } from './AppModal';
import { Button } from '../';
import { Form, Input, Space, Typography } from 'antd';

import { useNotificationContext } from '../../providers/NotificationProvider';
import { ValidationErrors } from '../../constants';

import { useResetOneTimePasswordMutation } from '../../api/auth';
import { handleError, getSessionVar } from '../../lib/helpers';

export const ResetOneTimePasswordModal = ({ open, onCancel }) => {
    const [form] = Form.useForm();

    const { notifySuccess, notifyError } = useNotificationContext();
    const [resetOneTimePassword, { isLoading }] = useResetOneTimePasswordMutation();

    const onFinish = async () => {
        try {
            const { id } = getSessionVar('userRecord');
            const { password, confirmPassword } = await form.validateFields();
            await resetOneTimePassword({ userId: id, password, confirmPassword }).unwrap();
            notifySuccess({
                message: 'Password Reset',
                description: 'Your password has been reset. You can now log in with your new password.',
                onClose: () => {
                    sessionStorage.removeItem('passwordResetToken');
                    window.location.reload();
                    let userRecord = getSessionVar('userRecord');
                    if (userRecord && userRecord.is_one_time_password) {
                        userRecord.is_one_time_password = false;
                    }
                },
            });
        } catch (error) {
            handleError(error, notifyError, 'Error resetting password');
        }
    };

    return (
        <AppModal
            title="Reset Password"
            onCancel={onCancel}
            open={open}
            closable={false}
            maskClosable={false}
            footer={null}
        >
            <Typography.Paragraph>Please reset your password</Typography.Paragraph>
            <Form
                form={form}
                name="reset-password"
                layout="vertical"
                initialValues={{ remember: true }}
                style={{ maxWidth: 600 }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="password"
                    label="New Password"
                    rules={[{ required: true, message: ValidationErrors.password }]}
                >
                    <Input placeholder="New Password" type="password" />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    label="Confirm Password"
                    dependencies={['password']}
                    rules={[
                        { required: true, message: ValidationErrors.confirmPassword },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The two passwords do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input placeholder="confirm password" type="password" />
                </Form.Item>
                <Form.Item style={{ textAlign: 'right' }}>
                    <Space>
                        <Button key="cancel" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button key="submit" type="primary" loading={isLoading} htmlType="submit">
                            Reset Password
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </AppModal>
    );
};
